import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import routes from '@Constants/Routes'
import { trackEvent } from '@Utilities/marketingTags'

/** Bottom call-to-action band — navy→blue gradient + yellow sign-up button. Static copy. */
const BottomCta: React.FC = () => {
	const [t] = useTranslation('landingPage', { keyPrefix: 'bottom_cta' })
	const navigate = useNavigate()
	return (
		<Section>
			<Band>
				<Title>{t('title', { defaultValue: 'جاهز تبدأ رحلتك؟ سجّل دلوقتي' })}</Title>
				<Sub>{t('sub', { defaultValue: 'كل اللي محتاجه للثانوية في مكان واحد.' })}</Sub>
				<YellowBtn
					type="button"
					onClick={() => {
						trackEvent('CTAClick', { cta_text: 'signup', cta_location: 'bottom_cta' })
						navigate(routes.signup)
					}}
				>
					{t('cta', { defaultValue: 'إنشاء حساب مجاني' })}
				</YellowBtn>
			</Band>
		</Section>
	)
}

export default BottomCta

const Section = styled.section`
	margin: 4px 16px 20px;
`
const Band = styled.div`
	background: var(--blue);
	border-radius: var(--r-xl);
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
	text-align: center;
	padding: 24px 16px;
`
const Title = styled.h2`
	margin: 0;
	font: var(--fw-bold) var(--fs-title) var(--font-sans);
	color: var(--text-on-brand);
`
const Sub = styled.p`
	margin: 0;
	font: var(--fw-regular) 13px var(--font-sans);
	color: rgba(255, 255, 255, 0.85);
`
const YellowBtn = styled.button`
	height: 44px;
	padding: 0 24px;
	border: none;
	border-radius: var(--r-md);
	background: var(--yellow);
	color: var(--navy);
	font: var(--fw-bold) var(--fs-body) var(--font-sans);
	font-family: var(--font-sans);
	cursor: pointer;
	transition: filter var(--dur-fast) var(--ease);
	&:hover {
		filter: brightness(0.95);
	}
`
